import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navigation from './components/Navigation';
import Home from './components/Home';
import EventSchedule from './components/EventSchedule';
import TravelInfo from './components/TravelInfo';
import GeneralInfo from './components/GeneralInfo';
import Rsvp from './components/Rsvp';
import ScrollToTop from './components/ScrollToTop';
import './App.css';

function App() {
    return (
        <Router>
            <ScrollToTop />
            <div className="App">
                <Navigation />
                <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/info" element={<GeneralInfo />} />
                    <Route path="/schedule" element={<EventSchedule />} />
                    <Route path="/travel" element={<TravelInfo />} />
                    <Route path="/rsvp" element={<Rsvp />} />
                </Routes>
            </div>
        </Router>
    );
}

export default App;
